import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_REFRESH, AUTH_PASSWORD_CHANGE, AUTH_SESSION_MANAGE, AUTH_SESSION_REVOKE, AUTH_READ_PROFILE, AUTH_SWITCH_CONTEXT, DASHBOARD_VIEW, NAVIGATION_SHELL_READ, NAVIGATION_ROUTES_READ, NAVIGATION_ROUTE_READ, NAVIGATION_HUB_READ, SETTINGS_VIEW, SETTINGS_PROFILE, SETTINGS_PROFILE_UPDATE, SETTINGS_PREFERENCES, SETTINGS_PREFERENCES_UPDATE, SETTINGS_MFA, SETTINGS_SECURITY, TRANSACTION_LIST, TRANSACTION_GET, TRANSACTION_CREATE, TRANSACTION_SUBMIT, TRANSACTION_WITHDRAW, HOLDINGS_VIEW, REPORTS_VIEW, REPORT_DETAIL_READ, } from '../../operations/operation-ids.js';
/**
 * Organization user base: active-organization business operations from the
 * assigned bundles.  No Admin Hub, no organization-management resources.
 */
export const ORGANIZATION_USER_BASE_OPERATIONS = [
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REFRESH,
    AUTH_PASSWORD_CHANGE,
    AUTH_SESSION_MANAGE,
    AUTH_SESSION_REVOKE,
    AUTH_READ_PROFILE,
    AUTH_SWITCH_CONTEXT,
    DASHBOARD_VIEW,
    NAVIGATION_SHELL_READ,
    NAVIGATION_ROUTES_READ,
    NAVIGATION_ROUTE_READ,
    NAVIGATION_HUB_READ,
    SETTINGS_VIEW,
    SETTINGS_PROFILE,
    SETTINGS_PROFILE_UPDATE,
    SETTINGS_PREFERENCES,
    SETTINGS_PREFERENCES_UPDATE,
    SETTINGS_MFA,
    SETTINGS_SECURITY,
    TRANSACTION_LIST,
    TRANSACTION_GET,
    TRANSACTION_CREATE,
    TRANSACTION_SUBMIT,
    TRANSACTION_WITHDRAW,
    HOLDINGS_VIEW,
    REPORTS_VIEW,
    REPORT_DETAIL_READ,
];
